import Divider from '@zenbusiness/zui/Divider';
import superstyled from '@zenbusiness/zui/styles/superstyled';

export const ZUIDivider = superstyled({
  name: 'ZUIDivider',
  slot: 'Root',
  tag: Divider,
  styles: ({ theme, height }) => ({
    height: `${height}px`,
    borderRadius: 5,
    borderBottomWidth: 0,
    background: `linear-gradient(225deg, ${theme.palette.secondary.main} 0%, ${theme.palette.background.blue.main} 100%)`
  })
});
